export default "__VITE_PUBLIC_ASSET__70774a1a__"